import { ElMessage, ElMessageBox } from "element-plus";
import { computed, reactive, ref } from "vue";
import { postDownload } from "@/utils";
import { queryTable } from "@/api/inventory";

export default function useInventoryTable() {
  // 搜索表单ref
  const searchRef = ref(null);

  // 编辑ref
  const editRef = ref(null);

  // 搜索表单
  const searchData = reactive({
    name: null,
    number: null,
    categoryId: null,
    brand: null,
    model: null,
    tissue: null,
    warehouseId: null,
    lowerQuantity: null,
    upperQuantity: null,
  });

  // 分页参数
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 表格列配置
  const columns = ref([
    {
      label: "物料编号",
      prop: "number",
    },
    {
      label: "物料名称",
      prop: "name",
    },
    {
      label: "物料类别",
      prop: "categoryName",
    },
    {
      label: "品牌",
      prop: "brand",
    },
    {
      label: "规格型号",
      prop: "model",
    },
    {
      label: "单位",
      prop: "unit",
    },

    {
      label: "仓库",
      prop: "warehouseNameList",
    },
    {
      label: "库存数量",
      prop: "totalQuantity",
    },
    {
      label: "库存上限",
      prop: "upperLimit",
    },
    {
      label: "库存下限",
      prop: "lowerLimit",
    },
    {
      label: "库存单价",
      prop: "realTimeUnitPrice",
    },
  ]);

  // 表格数据
  const tableData = ref([]);

  // 表格遮罩
  const tableLoading = ref(false);

  // 获取列表数据
  const getList = () => {
    tableLoading.value = true;
    queryTable({
      ...searchData,
      page: pages.page,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 点击重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    searchData.lowerQuantity = null;
    searchData.upperQuantity = null;
    getList();
  };

  // 点击编辑
  const handleAdjust = (row, type) => {
    editRef.value?.handleDialogOpen({ row, type });
  };

  // 导出
  const handleExport = () => {
    ElMessageBox.confirm("确定导出库存数据吗？", "导出", {
      confirmButtonText: "导出",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        postDownload("/inventory/export", {}, "库存管理.xlsx");
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  return {
    searchRef,
    searchData,
    columns,
    tableData,
    tableLoading,
    pages,
    editRef,
    getList,
    handleReset,
    handleAdjust,
    handleExport,
  };
}
